import React from "react";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import {
  Box,
  Divider,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLanguage } from "../../Language";
import { ViewSiteButton } from "./ViewSiteButton";
import { Bookjacket, JacketSize } from "../account/lists/Bookjacket";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { AddToListButton } from "../resource/AddToListButton";
import { SanitizedHTML } from "../../SanitizedHTML";
import { ContentDMOrRSSFormat } from "../search/ls/ContentDMOrRSSItem";

interface NewsFeedLayoutProps {
  resource: ResourceDWR;
}

export const NewsFeedLayout = ({ resource }: NewsFeedLayoutProps) => {
  const { translate } = useLanguage();
  const theme = useTheme();
  const fullSize = useMediaQuery(theme.breakpoints.up("md"));
  if (resource.rtype === 1) {
    throw new Error("Unexpected resource type");
  }

  const getPubDate = (resource: ResourceDWR) => {
    return resource &&
      resource.publicationDate &&
      resource.publicationDate.publicationDate
      ? "(" + resource.publicationDate.publicationDate + ")"
      : "";
  };

  return (
    <>
      <Stack direction={fullSize ? "row" : "column"} sx={{ gap: 2, mt: 2 }}>
        <Stack
          direction={"column"}
          sx={{
            alignItems: "center",
            flexGrow: 0,
            flexShrink: 0,
            width: fullSize ? "272px" : "auto",
          }}
          gap={1}
          margin={1}
        >
          <Bookjacket
            showFormat={false}
            size={JacketSize.lg}
            sx={{
              minHeight: "200px",
              maxWidth: "200px",
              margin: "0 auto 16px",
            }}
            resource={resource}
          ></Bookjacket>
        </Stack>
        <Stack sx={{ flexGrow: 3, flexShrink: 1, minWidth: 0 }}>
          <Typography variant="h4" component={"h2"}>
            {resource.shortTitle}
          </Typography>
          <Box>
            <ContentDMOrRSSFormat resource={resource} />
          </Box>
          <Stack
            direction={fullSize ? "row" : "column-reverse"}
            sx={{
              gap: 1,
              paddingTop: 2,
              paddingBottom: 2,
            }}
          >
            <ViewSiteButton site={resource} />
            <AddToListButton resourceId={resource.id} />
          </Stack>
          <Divider />
          <Box sx={{ mt: 2, mb: 2 }}>
            <SanitizedHTML html={resource.content} />
          </Box>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            {getPubDate(resource)}
            {resource.rtype === 2 && (
              <Box>
                <RssFeedIcon />
              </Box>
            )}
            <Link target="_blank" href={resource.link}>
              {translate("readMore")}
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
